<template>
  <div :class="classObject" @click="open">
    <multiselect
      ref="multiselect"
      v-model="selectedData"
      :id="id"
      :name="name"
      :placeholder="placeholder || ' '"
      :options="options"
      :multiple="multiple"
      :label="label"
      :track-by="trackBy"
      :taggable="taggable"
      :limit="limit"
      :limitText="limitText"
      :searchable="searchable"
      :group-values="groupValues"
      :group-label="groupLabel"
      @tag="onTag"
      :class="{long: long}"
      :autocomplete="autocomplete"
    >
      <!-- Tag -->
      <template slot="tag" slot-scope="{ option, remove }">
        <span class="c-form-multiselect__tag">
          <span>{{ option.name }}</span>
          <span class="c-form-multiselect__remove" @click="remove(option)">
            <icon name="cross" width="10" height="10"></icon>
          </span>
        </span>
      </template>
    </multiselect>
    <div class="c-form-field__drop-icon" v-if="!isValid || showDropIcon">
      <icon name="drop-arrow" width="8" height="8"></icon>
    </div>
    <div class="c-form-field__valid-icon" v-if="showValidTick && isValid">
      <icon name="tick" width="16" height="16"></icon>
    </div>
    <span class="c-form__validation-message" v-if="error">{{ error }}</span>
  </div>
</template>

<script>
export default {
  name: "form-multiselect",

  props: {
    id: [Number, String],
    name: String,
    value: null,
    options: Array,
    multiple: {
      type: Boolean,
      default: false
    },
    label: String,
    trackBy: String,
    taggable: Boolean,
    error: String,
    limit: Number,
    placeholder: String,
    autocomplete: {
      type: String,
      default: "on"
    },
    searchable: {
      type: Boolean,
      default: true
    },
    limitText: {
      type: Function,
      default: count => `+${count}`
    },
    showValidTick: Boolean,
    showDropIcon: Boolean,
    ghost: Boolean,
    groupValues: {
      type: String,
      default: null
    },
    groupLabel: {
      type: String,
      default: null
    },
    long: Boolean
  },

  $_veeValidate: {
    value() {
      return this.selectedData;
    }
  },

  computed: {
    classObject() {
      return {
        "c-form-multiselect": true,
        "c-form-multiselect--ghost": this.ghost,
        "has-errors": this.error
      };
    },

    selectedData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },

    isValid() {
      if (!this.multiple) {
        return !!(this.value && !this.error);
      }
      if (this.value) {
        return !!(this.value.length && !this.error);
      }
    }
  },

  methods: {
    onTag(option) {
      // TODO: In the instance where we want to tag, but only allow one option
      // set selectedData to a fake object just so it prefills
      if (!this.multiple) {
        this.selectedData = { id: null, name: option };
      }
      this.$emit("tag", option);
    },

    open() {
      this.$refs.multiselect.isOpen = true;
      if (this.$refs.multiselect.$refs.search) {
        this.$refs.multiselect.$refs.search.focus();
      }
    },

    close() {
      this.$refs.multiselect.isOpen = false;
    }
  }
};
</script>


<style lang="scss">
.c-form-field__drop-icon {
  position: absolute;

  top: 0;
  right: 0;
  bottom: 0;
  left: auto;

  max-height: 54px;
  width: 3em;

  color: $colour-nhs-dark-grey;
  pointer-events: none;

  display: flex;
  align-items: center;
  justify-content: center;

  .svg-icon {
    // position: absolute;
    // top: 50%;
    // left: 50%;
    // transform: translate(-25%, -25%);
  }
}

.c-form-field__valid-icon {
  position: absolute;
  right: 0;
  top: 0;
  height: 54px;
  width: 54px;
  padding-top: 18px;
  padding-left: 20px;
  color: #0cce4e;
  pointer-events: none;
}

.multiselect {
  outline: none;
  min-height: 54px;

  * {
    outline: none;
  }

  color: #202020;
  position: relative;

  &__tags {
    padding: 0.5em;
    border-radius: 4px;
    background: $colour-nhs-white;
    border: 2px solid #c9ced4;
    min-height: 54px;
    // padding-right: 54px;

    display: flex;
    flex-wrap: wrap;
    align-content: center;
  }

  &--active &__tags {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  &--active &__tags,
  &--active &__content-wrapper {
    border-color: $colour-nhs-blue;
  }

  &--active &__content-wrapper {
    border-top: none;
  }

  &__placeholder {
    color: $colour-nhs-mid-grey;
  }

  &__placeholder,
  &__input,
  &__single {
    padding: 0.5em 0.25em;
    margin: 0;
  }

  &__single {
    width: 100%;
  }

  &__input {
    border: none;
    width: auto;
    padding-left: 0;
    margin-left: 0.25em;
    flex-grow: 1;
    padding: 0;
    max-width: 90%;
  }

  &__tags-wrap {
    display: inline-block;
    margin-top: -6px;
  }

  // div
  &__content-wrapper {
    border: 2px solid #c9ced4;
    margin-top: -2px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    overflow-y: scroll;

    // min-width: 240px;
    min-width: 100px;

    position: absolute;
    left: 0;
    right: 0;
    z-index: 11;
    background: $colour-nhs-white;
  }

  &.long {
    min-width: 240px;

    @media (min-width: 768px) and (max-width: 1024px) {
      min-width: 175px;
    }
    @media (min-width: 1280px) {
      min-width: 100px;
    }
  }

  // .. ul
  &__content {
    list-style: none;
    padding: 0;
    margin: 0;
    display: block;
    width: 100%;
  }

  &__option {
    padding: 0.5em 1em;
    cursor: pointer;
    display: block;
  }

  &__option--selected {
    color: #c9ced4;

    &:hover,
    &:focus {
      background: $colour-nhs-pale-grey;
    }
  }

  &__option:hover:not(.multiselect__option--selected),
  &__option:focus:not(.multiselect__option--selected),
  &__option:active:not(.multiselect__option--selected),
  .multiselect__option--highlight
   {
    background: $colour-nhs-pale-grey;
    color: $colour-nhs-blue;
  }

  // group
  &__option--group {
    font-weight: bold;
    background: $colour-nhs-pale-grey;
  }
}

.c-form-multiselect {
  position: relative;
  &__tag,
  .multiselect__tags > .multiselect__strong {
    display: inline-block;
    background: $colour-nhs-dark-grey;
    font-size: 14px;
    color: $colour-nhs-white;
    border-radius: 4px;
    font-weight: normal;
    height: 30px;
  }

  &__tag {
    margin-top: 6px;
    padding: 0.5em 2em 0.5em 0.5em;
    position: relative;
  }

  &__tag:hover,
  &__tag:focus {
    background: lighten($colour-nhs-dark-grey, 10%);
  }

  .multiselect__tags > .multiselect__strong {
    padding: 0.5em 0.5em;
  }

  &__tag:not(:last-of-type) {
    margin-right: 0.25em;
  }

  &__tag:last-of-type {
    margin-right: 0.5em;
  }

  &__remove {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    cursor: pointer;
    display: inline-block;
    margin-left: 4px;
    padding: 0.5em;
  }

  &.has-errors .multiselect__tags,
  &.has-errors .multiselect__content-wrapper {
    border-color: $colour-nhs-emergency-red;
  }
}

.c-form-multiselect--ghost {
  .multiselect__tags {
    background: none;
    border: none;
  }

  .multiselect__content-wrapper {
    border: none;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.11);
  }
}
</style>
